export default "Hospital # 3 de-icing U/S.";